import { useEffect } from "react";
import { useTranslation } from "react-i18next";

// 404 dentro de la app antigua (navegación interna a una ruta que no
// existe). Antes el comodín pintaba la home. noindex por si acaso.
export default function NotFound() {
  const { i18n } = useTranslation();
  const es = !i18n.language?.startsWith("en");
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, follow";
    document.head.appendChild(m);
    const prev = document.title;
    document.title = es ? "Página no encontrada | TripTick" : "Page not found | TripTick";
    return () => {
      m.remove();
      document.title = prev;
    };
  }, [es]);
  const base = es ? "/es" : "/en";
  const btn = { padding: "12px 22px", borderRadius: 999, textDecoration: "none", fontWeight: 600 };
  return (
    <main style={{ minHeight: "80vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 18, padding: "48px 20px", textAlign: "center" }}>
      <p style={{ fontSize: 15, letterSpacing: 2, textTransform: "uppercase", color: "#8b7a5e", margin: 0 }}>Error 404</p>
      <h1 style={{ fontFamily: "nyght_serifregular, serif", fontWeight: 400, fontSize: "clamp(34px, 6vw, 56px)", margin: 0 }}>
        {es ? "Esta página no existe" : "This page doesn't exist"}
      </h1>
      <p style={{ maxWidth: 460, fontSize: 17, lineHeight: 1.5, margin: 0 }}>
        {es ? "Puede que el enlace esté mal escrito o que la página ya no exista." : "The link may be mistyped or the page may no longer exist."}
      </p>
      <nav style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center" }}>
        <a href={es ? "/es/itinerarios" : "/en/itineraries"} style={{ ...btn, background: "#0fa4ff", color: "#fff" }}>
          {es ? "Crear un viaje con IA" : "Plan a trip with AI"}
        </a>
        <a href={base} style={{ ...btn, background: "#fff", color: "#2b2b2b" }}>{es ? "Ir al inicio" : "Go home"}</a>
      </nav>
    </main>
  );
}
